// ContactInfoStyles.js
import styled, { css } from "styled-components";

const card = css`
  background: transparent;
  border-radius: 18px;
`;

export const Wrap = styled.section`
  --accent: #d4af37;
  --ink: #111;
  --muted: rgba(0, 0, 0, 0.6);
  padding: clamp(18px, 4vw, 28px) 12px 36px;
  background: transparent;
  color: var(--ink);
`;

export const Inner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  ${card}
  padding: clamp(18px, 4vw, 32px);
  position: relative;
  overflow: hidden;
`;

/* ... Head / Brand styles identice ... */

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: clamp(14px, 2.6vw, 22px);
  @media (min-width: 860px) {
    grid-template-columns: 1.1fr 1fr 1fr;
  }
`;

export const Block = styled.section`
  ${card}
  padding: 56px 16px 16px; /* spațiu sus pentru top bar */
  position: relative;

  /* bordură aurie pe toată casuța */
  border-radius: 18px; /* asigurăm același radius ca în card */
  background: linear-gradient(#fff, #fff) padding-box,
    /* interior */
      linear-gradient(135deg, var(--accent), rgba(212, 175, 55, 0.35))
      border-box; /* cadru */
  border: 1.5px solid transparent;

  /* ușor highlight aurit */
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.08),
    inset 0 0 0 1px rgba(0, 0, 0, 0.04), 0 0 0 2px rgba(212, 175, 55, 0.08);
`;

/* --- Top bar cu titlu + icon --- */
export const TopBar = styled.div`
  position: absolute;
  inset: 0 0 auto 0;
  height: 46px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 16px;
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;

  /* fundal negru solid */
  background: #000000;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);

  &:after {
    content: "";
    position: absolute;
    left: 16px;
    right: 16px;
    bottom: 0;
    height: 2px;
    background: linear-gradient(
      90deg,
      var(--accent),
      rgba(212, 175, 55, 0.25),
      transparent
    );
    opacity: 0.9;
  }
`;

export const TopBarIcon = styled.i`
  color: var(--accent);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
`;

export const TopBarTitle = styled.h4`
  margin: 0;
  font-size: 15px;
  font-weight: 800;
  color: #fff;
  letter-spacing: 0.3px;
`;

/* restul (List, Item, Key, Val, Actions, CallBtn, MapBtn, Note) rămân la fel */

export const Head = styled.header`
  text-align: center;
  margin-bottom: clamp(12px, 2.5vw, 20px);
`;

export const BrandRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px;
`;

export const BrandDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--accent);
  box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.22);
`;

export const Title = styled.h3`
  margin: 0;
  font-weight: 800;
  letter-spacing: 0.3px;
  font-size: clamp(18px, 2.6vw, 24px);
  color: var(--ink);
  text-transform: none;
`;

export const BlockHead = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
`;

export const BlockTitle = styled.h4`
  margin: 0;
  font-size: 15px;
  letter-spacing: 0.4px;
  color: var(--ink);
  font-weight: 800;

  /* insignă subtilă negru + auriu */
  padding: 6px 10px;
  border-radius: 999px;
  background: linear-gradient(#111, #111) padding-box,
    linear-gradient(135deg, var(--accent), rgba(212, 175, 55, 0.35)) border-box;
  color: #fff;
  border: 1px solid transparent;
`;

export const Line = styled.i`
  height: 1px;
  display: block;
  background: linear-gradient(
    to right,
    var(--accent),
    rgba(212, 175, 55, 0.2),
    transparent
  );
`;

export const List = styled.ul`
  list-style: none;
  margin: 6px 0 0;
  padding: 0;
  display: grid;
  gap: 6px;
`;

export const Item = styled.li`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: baseline;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px dashed rgba(17, 17, 17, 0.08);

  &:last-child {
    border-bottom: 0;
  }
`;

export const Key = styled.span`
  color: var(--muted);
  font-size: 14px;
`;

export const Actions = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 12px;
  flex-wrap: wrap; /* ✅ */
  ${({ $center }) =>
    $center &&
    css`
      justify-content: center;
    `}
`;

export const Val = styled.span`
  font-weight: 700;
  font-size: 14px;
  color: #8b8064;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  a {
    color: inherit;
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
`;

/* buton premium negru cu bordură aurie */
const baseBtn = css`
  appearance: none;
  padding: 12px 18px;
  border-radius: 999px;
  font-weight: 800;
  font-size: 13px;
  text-decoration: none;
  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s,
    background-color 0.15s, color 0.15s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  letter-spacing: 0.2px;
  border: 1px solid transparent;

  &:active {
    transform: translateY(0);
    box-shadow: none;
  }
`;

export const CallBtn = styled.a`
  ${baseBtn}
  background: #111;
  color: var(--accent);
  border-color: var(--accent);
  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: translateY(-1px);
    background: linear-gradient(#111, #0b0b0b);
    color: #fff;
    box-shadow: 0 14px 24px rgba(0, 0, 0, 0.28);
  }
`;

export const MapBtn = styled.a`
  ${baseBtn}
  background: #fff;
  color: #111;
  border-color: rgba(0, 0, 0, 0.12);

  &:hover {
    transform: translateY(-1px);
    border-color: var(--accent);
    box-shadow: 0 10px 18px rgba(212, 175, 55, 0.18);
    color: #111;
  }
`;

export const Note = styled.p`
  margin: 12px 0 0;
  font-size: 12px;
  color: var(--muted);
  text-align: center;
`;
